import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function PaymentCancelPage() {
  return (
    <div 
      className="min-h-[80vh] flex items-center justify-center py-12 px-4"
      data-testid="payment-cancel-page"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-lg text-center"
      >
        <div className="bg-white p-8 rounded-xl border border-slate-200 shadow-sm">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-8 w-8 text-amber-600" />
          </div>
          
          <h1 className="text-2xl font-semibold text-[#1A365D]">
            Payment Cancelled
          </h1>
          
          <p className="text-slate-600 mt-4">
            Your payment was cancelled. No charges were made to your account.
          </p>
          
          <p className="text-sm text-slate-500 mt-2">
            If you experienced any issues during checkout, please contact our support team.
          </p>
          
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/pricing">
              <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.98 }}>
                <Button className="w-full sm:w-auto bg-[linear-gradient(160deg,_#00B4B4,_#2BC3C3)] text-white">
                  <RefreshCw className="mr-2 h-4 w-4" />
                  Try Again
                </Button>
              </motion.div>
            </Link>
            
            <Link to="/">
              <Button variant="outline" className="w-full sm:w-auto">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Home
              </Button>
            </Link>
          </div>
          
          <div className="mt-8 p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">
              Need help? Call us at{' '}
              <a href="tel:1-844-499-3355" className="text-[#00B4B4] font-medium hover:underline">
                1-844-499-3355
              </a>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
